import { render } from "./PointHistory.vue?vue&type=template&id=5029a3db"
import script from "./PointHistory.vue?vue&type=script&lang=js"
export * from "./PointHistory.vue?vue&type=script&lang=js"

import "./PointHistory.vue?vue&type=style&index=0&id=5029a3db&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__